import { lazy } from 'react';

// Asociación verificador ↔ manufacturer (tabla dedicada verifier_fabricante).
// Reutiliza la UI del módulo del transformador vía ManufacturerVerifierContainer,
// que le inyecta los endpoints *-manufacturer.
const ManufacturerVerifierConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/configuration/verifier',
			component: lazy(() => import('./ManufacturerVerifierContainer'))
		}
	]
};

export default ManufacturerVerifierConfig;
